export default __webpack_public_path__ + "static/media/zalo.6462d2bb.png";